module.exports = __webpack_public_path__ + "img/equipment_2.8f99b1e4.jpg";